import { useState, useEffect } from "react";

export interface TagResourceCounts {
  devices: number;
  profiles: number;
  applications: number;
  configurations: number;
  patchPolicies: number;
  users: number;
  total: number;
}

export const useTagResourceCounts = (tagId: string) => {
  const [counts, setCounts] = useState<TagResourceCounts>({
    devices: 0, profiles: 0, applications: 0, configurations: 0, patchPolicies: 0, users: 0, total: 0
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchResourceCounts = async () => {
    if (!tagId) return;
    // TODO: Wire to tag assignment API for resource counts
    setIsLoading(false);
  };

  useEffect(() => {
    fetchResourceCounts();
  }, [tagId]);

  return { counts, isLoading, error, refetch: fetchResourceCounts };
};
